import type { Profil } from './types';

/**
 * Qui tient le répertoire commun (CDC §6.10, §5.1).
 *
 * Lire le répertoire est affaire d'écran (`ped-repertoire`, envoyé par l'API) ;
 * le **tenir** — ajouter un contact, corriger une fiche partenaire — est
 * affaire de profil, et la garde qui compte est `exigerProfil` côté serveur.
 * Cette liste n'existe que pour ne pas proposer un bouton qui échouerait.
 *
 * Elle est ici plutôt que recopiée dans chaque écran : deux copies auraient
 * fini par diverger, et un bouton serait apparu là où l'API refuse.
 */
export function peutTenirLeRepertoire(profil: Profil | undefined): boolean {
  if (!profil) return false;
  // Le pédagogique : l'assistant(e) seul(e), à qui l'API ouvre l'écran à
  // l'essai (TF-468) ; le responsable ne l'atteint pas (TF-467).
  return (
    profil === 'RELATION_ENTREPRISE' ||
    profil === 'RECRUTEMENT' ||
    profil === 'PEDAGOGIQUE' ||
    profil === 'DIRECTION'
  );
}

/**
 * Le dossier d'une organisation (`/ped-repertoire/:id`) est gardé côté serveur
 * par `ped-repertoire` **ou** `com-entreprises`. Sans l'un des deux — le pôle
 * pédagogique dans le matching ou les immersions (TF-467) —, le nom s'affiche
 * sans lien plutôt que de mener à un refus.
 */
export function peutOuvrirDossierOrganisation(peutAcceder: (ecran: string) => boolean): boolean {
  return peutAcceder('ped-repertoire') || peutAcceder('com-entreprises');
}
